// Source: https://docs.google.com/spreadsheets/d/1NjxODRYzLrsaIEW1qvsXS0Ea0H2LFHIpPFtM3pbjWkU/edit#gid=0
// All the countries under the "Countries where Coursera is unavialble or access is limted - DO NOT LAUNCH PROFILE / SUNSET OLD PROFILE" columns
// inside the "Unsafe Countries" sheet
const RESTRICTED_COUNTRIES = [
  'Iran',
  'Sudan',
  'Crimea',
  'Cuba',
  'Syria',
  'Russia',
  'Sudan',
  'South Sudan',
  'Venezuela',
  'North Korea',
  'China',
];

export function getAlgoliaRestrictedCountryFilters() {
  return RESTRICTED_COUNTRIES;
}

export function getIsUSOrIndia(
  inferredUserLocationCountryCode: string | null | undefined,
  locationCountryName: string | null | undefined
) {
  if (inferredUserLocationCountryCode) {
    return inferredUserLocationCountryCode === 'US' || inferredUserLocationCountryCode === 'IN';
  } else {
    // TODO: remove this case when inferredUserLocationCountryCode is implemented for the externalId query
    return locationCountryName === 'India' || locationCountryName === 'United States';
  }
}
